<template>
    <div class="container_box">
        <nav-box @userInfo='getUserInfo'></nav-box>
        <h1 class="consultTitle" >{{consultTitle}}</h1>
        
        <p class="create_time">{{createTime}}</p>
        <div class="consultContent">{{consultContent}}</div>
        <h2 class="consult_h2"><span>回复内容</span><el-button style="float:right" @click="deleteConsult" type="danger">删除本贴</el-button></h2>
         <h1 class="consult_h1"></h1>
        <div class="message_box">
            <li :class="{'selfMessage':item.contentUserType === 10}"  v-for="item in contentList"><span>{{item.contentUserName+'：'}}</span><span>{{item.content}}</span><p><span class="deleteMessage" @click="deleteMessage($event)" :consultContentNo="item.consultContentNo" v-if="item.contentUserType === 10">删除</span>{{item.createTime.slice(0,10) +'\xa0' +item.createTime.slice(11,19)}}</p></li>
        </div>
        <div class="textArea_container">
            <el-input type="textarea" v-model="sendMessage" :autosize="{ minRows: 3}" :disabled="consultStatus === 2"></el-input>
        </div>
        <div class="button_container">
            <el-button type="primary" @click="addMessage" :disabled="consultStatus === 2" >立即回复</el-button>
        </div>
    </div>    
</template>
<script>
import { mapMutations } from "vuex";
import { request } from "../../network/request";
import NavBox from '../../components/NavBox.vue'

export default ({
    name:'ConsultInfo',
    data(){
        return{
            userInfo:{},
            consultTitle:'',
            createTime:'',
            consultContent:'',
            contentList:[],
            sendMessage:'',
            consultStatus:2,
        }
    },
    created(){
        this.loadingMessage()
    },
    computed: {
        getConsultTopicNo(){
            return this.$route.params.consultId
        }
    },
    methods:{
         ...mapMutations(["changeLogin"]),
          getUserInfo(val){
            this.userInfo = val;
          },
          loadingMessage(){
              request({
                method:'get',
                url:'/api/Consult/Detail',
                params:{
                    consultTopicNo:this.getConsultTopicNo
                }
            }).then(res =>{
                if(res.data.code === 21002){
                    this.changeLogin({ userToken: "" });
                    this.$router.push('/login')
                }else if(res.data.code === 0){
                    this.consultTitle = res.data.content.consultTitle
                    this.createTime = res.data.content.createTime.slice(0,10) +'\xa0\xa0\xa0' + res.data.content.createTime.slice(11,19);
                    this.consultContent = res.data.content.consultContent;
                    this.contentList = res.data.content.contentList;
                    this.consultStatus = res.data.content.consultStatus
                }else{
                    this.$message({type:'error',message:res.data.msg})
                }
                
            }) 
          },
          addMessage(){
              if(!!this.sendMessage){
                  request({
                      url:'/api/Consult/Reply',
                      method:'post',
                      data:{
                          "consultTopicNo": this.getConsultTopicNo,
                          "content": this.sendMessage
                      }
                  }).then(res =>{
                    if(res.data.code === 21002){
                        this.changeLogin({ userToken: "" });
                        this.$router.push('/login')
                    }else if(res.data.code === 0){
                        this.loadingMessage();
                        this.sendMessage = '';
                    }else{
                        this.$message({type:'error',message:res.data.msg})
                    }
                     
                  })
              }else{
                  this.$message({type:'error',message:'回复的内容不能为空',offset:100})
              }
          },
          deleteConsult(){
               this.$confirm('此操作将永久删除该咨询帖, 是否继续?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() =>{
                    request({
                        url:'/api/Consult/Delete',
                        method:'post',
                        data:{
                            key:this.$route.params.consultId
                        },
                    }).then(res =>{
                    if(res.data.code === 21002){
                        this.changeLogin({ userToken: "" });
                        this.$router.push('/login')
                    }else if(res.data.code === 0){
                        this.$message({type:'success',message:'删除成功'})
                        this.$router.push('/consultList');
                    }else{
                        this.$message({type:'error',message:res.data.msg})
                    }
                        
                    })
                }).catch(() =>{
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })
          },
          deleteMessage($event){
              this.$confirm('此操作将永久删除该咨询帖, 是否继续?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
              }).then(() =>{
                  request({
                        url:'/api/Consult/DeleteReply',
                        method:'post',
                        data:{
                            key:$event.target.getAttribute('consultContentNo')
                        },
                    }).then(res =>{
                    if(res.data.code === 21002){
                        this.changeLogin({ userToken: "" });
                        this.$router.push('/login')
                    }else if(res.data.code === 0){
                        this.$message({type:'success',message:'删除成功'})
                        this.loadingMessage();
                    }else{
                        this.$message({type:'error',message:res.data.msg})
                    }
                            
                    })
              }).catch(() =>{
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
              })
          }
    },
    components: {
        NavBox
    }
})
</script>
<style scoped>
    .consultTitle{
        width:800px;
        word-break: break-all;
        margin:0 auto;
        font-size:25px;
        padding-top:150px;
        text-align: center;
        margin-bottom:20px;
    }
    .create_time{
        text-align: center;
        font-size:14px;
        color:#a0a0a0;
    }
    .consultContent{
        width:800px;
        word-break: break-all;
        margin:0 auto;
        margin-top:20px;
        font-size:16px;
        line-height: 35px;
    }
     .consult_h2{
        width:800px;
        margin:0 auto;
        /* padding-top:20px; */
        font-size: 20px;
        padding:50px 0px;
        font-weight: 900;
    }
    .message_box{
        width:800px;
        margin:0 auto;
        background-color:#f7f8fa;
        padding:30px;
        margin-bottom:30px;
    }
    .message_box li{
        background-color: #ffffff;
        padding:10px 20px;
        margin-bottom: 20px;
        border-radius: 10px;
    }
    .message_box li:last-child{
        margin-bottom: 0px;
    }
    .message_box li>p{
        text-align: right;
        color:#a0a0a0;
    }
    .textArea_container{
        width:800px;
        margin:0 auto;
    }
    li.selfMessage{
        background-color:rgb(160, 234, 111);
    }
    .button_container{
        width:800px;
        margin:0 auto;
        padding:20px 0px;
        text-align: right;
    }
    .deleteMessage{
        margin-right: 10px;
        cursor: pointer;
        color:#1c80b3;
    }
    @media screen and (max-width: 480px){
        .consultTitle{
            width:100%;
            padding:0px 20px;
            padding-top:100px;
        }
        .consultContent{
            width:100%;
            padding:0px 20px;
        }
        .consult_h2{
            width:100%;
            padding:0px 20px;
            /* padding-top:20px; */
        }
    }
</style>
